"use strict";
/*
Copyright 2021 Splunk Inc.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalEventTarget = void 0;
class InternalEventTarget {
    constructor() {
        this.events = {};
    }
    addEventListener(type, listener) {
        if (!this.events[type]) {
            this.events[type] = [];
        }
        this.events[type].push(listener);
    }
    removeEventListener(type, listener) {
        if (!this.events[type]) {
            return;
        }
        const i = this.events[type].indexOf(listener);
        if (i >= 0) {
            this.events[type].splice(i, 1);
        }
    }
    emit(type, payload) {
        const listeners = this.events[type];
        if (!listeners) {
            return;
        }
        listeners.forEach(listener => {
            // Run it as promise so any broken code inside listener doesn't break the agent
            Promise.resolve({ payload }).then(listener);
        });
    }
}
exports.InternalEventTarget = InternalEventTarget;
//# sourceMappingURL=EventTarget.js.map